import "./FooterComponent.scss"
import footerRed from '../../resources/images/footers/ArtFooterRed.PNG';
import footerTeal from '../../resources/images/footers/ArtFooterTeal.PNG';
import footerPurple from '../../resources/images/footers/ArtFooterPurple.PNG';
import footerBlue from '../../resources/images/footers/ArtFooterBlue.PNG';
import footerGreen from '../../resources/images/footers/ArtFooterGreen.PNG';
import footerOrange from '../../resources/images/footers/ArtFooterOrange.PNG';
import footerDefault from '../../resources/images/footers/ArtFooterDefault.PNG';
import { COLOURS } from "../../constants/colours";
import { ROUTES } from "../../constants/routes";
import { useLocation } from "react-router-dom";

const currentYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
}

const getFooterImage = (colourClassName) => {
    switch (colourClassName.colourClassName) {
        case COLOURS.redStyle.className:
            return footerRed;
        case COLOURS.tealStyle.className:
            return footerTeal;
        case COLOURS.purpleStyle.className:
            return footerPurple;
        case COLOURS.blueStyle.className:
            return footerBlue;
        case COLOURS.greenStyle.className:
            return footerGreen;
        case COLOURS.orangeStyle.className:
            return footerOrange;
        default:
            return footerDefault;
    }
}

const FooterComponent = (colourClassName) => {
    const location = useLocation();
    
    return (
        <div className="footerContainer">
            { location.pathname === ROUTES.about && (
                <img src={getFooterImage(colourClassName)} alt="footer"/>
            )}
            <footer>
                <p className={`footerText about-${colourClassName.colourClassName.colourClassName}`}>© 2024-{currentYear()} Orla Curran Art. All rights reserved. All code, artwork and designs are property of Orla Curran and may not be used without permission.</p>
            </footer>
        </div>
    );
};

export default FooterComponent;